"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckLabel = exports.StyledCheckChild = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../utils/theme");
exports.StyledCheckChild = styled_components_1.default.span({
    color: theme_1.colors.grey700,
    transition: 'all .1s linear',
    userSelect: 'none'
});
var getStyles = function (flexDirection) {
    var _a, _b, _c;
    var styles = (_a = {},
        _a['row-reverse'] = (_b = {
                flexDirection: flexDirection
            },
            _b["" + exports.StyledCheckChild] = {
                paddingRight: theme_1.scaffolding.xs
            },
            _b),
        _a['default'] = (_c = {
                flexDirection: flexDirection
            },
            _c["" + exports.StyledCheckChild] = {
                paddingLeft: theme_1.scaffolding.xs
            },
            _c),
        _a);
    return styles[flexDirection] ? styles[flexDirection] : styles.default;
};
exports.StyledCheckLabel = styled_components_1.default.label(__assign({ WebkitTapHighlightColor: theme_1.colors.transparent, alignItems: 'center', cursor: 'pointer', display: 'flex', outline: 'none', position: 'relative' }, theme_1.font), function (_a) {
    var flexDirection = _a.flexDirection, justifyContent = _a.justifyContent, theme = _a.theme;
    return (__assign(__assign({}, getStyles(flexDirection)), { justifyContent: justifyContent }));
});
//# sourceMappingURL=ApCheckLabel.js.map